import React, { memo, useContext, useRef } from 'react';
import { shallowEqual, useSelector, history } from 'umi';
import classNames from 'classnames';
import { MenuItem } from '@/pages/dashboard/components/MenuItem';
import SvgIcon from '@/pages/home/components/SvgIcon';
import {
  MENU_OPTION_TYPE_DASHBOARD,
  MenuContext
} from '@/pages/dashboard/components/LeftMenu/components/Menu/config';
import { getBasePath } from '@/utils/utils';
import { getPathFromDashboard } from '@/pages/dashboard/utils/utils';
import { PAGE_TYPE_OUT_PATH, PAGE_TYPE_OUT_URL } from '@/pages/dashboard/_config/constant';

type IDashboardProps = {
  isSubFolder: boolean;
  parent: any;
  dashboard: any;
  menuOptionInfo: React.ComponentState;
  // 打开右侧操作弹窗
  openMenuOption: (type: string, menu: any, ele: EventTarget, folder?: any) => void;
  showNewMenusMap: any;
}

export default memo((props: IDashboardProps) => {
  const {
    isSubFolder = false,
    parent,
    dashboard,
    menuOptionInfo,
    openMenuOption,
    showNewMenusMap
  } = props;

  const { showBubble, hideBubble } = useContext(MenuContext);
  const dashboardRef = useRef<HTMLLIElement>(null);

  const { currentMenu, currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentMenu, currentGame } = state.dashboard;
    return {
      currentGame,
      currentMenu,
    };
  }, shallowEqual);

  // 获取a标签所需路径
  const getUrl = (dashboard: any) => {
    if (dashboard.page_type === PAGE_TYPE_OUT_PATH) {
      return `${getBasePath()}${dashboard?.url}`;
    }
    if (dashboard.page_type === PAGE_TYPE_OUT_URL) {
      return `${dashboard?.url}`;
    }
    const path = getPathFromDashboard(dashboard);
    return `/dashboard/game/${currentGame.game_code}/${path}`;
  };

  const handleClickDashboard = (dashboard: any): void => {
    if (dashboard.page_type === PAGE_TYPE_OUT_PATH) {
      window.open(`${getBasePath()}${dashboard?.url}`);
      return;
    }
    if (dashboard.page_type === PAGE_TYPE_OUT_URL) {
      window.open(`${dashboard?.url}`);
      return;
    }
    const path = getPathFromDashboard(dashboard);
    // dispatch({
    //   type: "dashboard/save",
    //   payload: {
    //     currentMenu: dashboard
    //   }
    // });
    history.push(`/dashboard/game/${currentGame.game_code}/${path}`);
  };

  const handleClickOption = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>): boolean => {
    e.stopPropagation();
    e.preventDefault();
    openMenuOption(MENU_OPTION_TYPE_DASHBOARD, dashboard, e.target, parent);
    return false;
  };

  const handleMouseEnter = () => {
    if (!showBubble || !dashboardRef.current || !dashboard?.text) return;
    const menuTitle = dashboardRef.current?.getElementsByClassName(`db-menu-title-${dashboard?.id}`)[0];
    if (menuTitle && menuTitle?.scrollHeight > menuTitle?.clientHeight) {
      showBubble(() => ({ ele: dashboardRef.current, content: dashboard?.text }));
    }
  };

  const handleMouseLeave = () => {
    hideBubble();
  };

  const showNew = showNewMenusMap.get(parent?.name_en)?.has(dashboard?.name_en);

  return <MenuItem
    ref={dashboardRef}
    // @ts-ignore
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    path={getUrl(dashboard)}
    title={
      <div className="left-nav-text">
        <div className={`left-nav-text-hd`}>
          <span className={`left-nav-text-title db-menu-title-${dashboard?.id}`}>{dashboard?.text}</span>
          {showNew ? (<span className="left-nav-notice">NEW</span>) : ""}
        </div>
        <span
          // onMouseDown={(e) => {
          //   e.stopPropagation();
          // }}
          onClick={handleClickOption}
          className='left-nav-absolute'
        >
          <SvgIcon type="more" />
        </span>
      </div>
    }
    // className={`left-nav-item left-nav-subsetbox js-menu-dashboard-${dashboard?.id} ${dashboard?.eleId ? dashboard?.eleId : ''}`}
    className={classNames({
      'left-nav-item': true,
      'left-nav-subsetbox': !isSubFolder,
      'left-nav-subset': isSubFolder,
      [`js-menu-dashboard-${dashboard?.id}`]: true,
      'active': menuOptionInfo.visible && menuOptionInfo.menu?.id === dashboard?.id,
      [dashboard?.eleId]: dashboard?.eleId
    })}
    selected={currentMenu?.id && currentMenu?.id === dashboard?.id}
    onClick={(e) => {
      handleClickDashboard(dashboard);
      e.preventDefault();
      return false;
    }}
  />;
});
